import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@/config/routes';
import { setAccessToken } from '@/lib/api/client';
import { getMeApi } from '@/lib/auth/authApi';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Point d'atterrissage après qu'un SUPER_ADMIN a cliqué "Impersonner" dans l'admin.
 * Lit le jeton temporaire depuis le fragment d'URL (#token=...),
 * hydrate le store en mode impersonation, puis redirige vers /mon-espace.
 *
 * Le fragment (#) n'est jamais envoyé au serveur.
 */
export default function ImpersonateCallback() {
  const navigate = useNavigate();
  const { startImpersonation } = useAuthStore();

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    const params = new URLSearchParams(hash);
    const token = params.get('token');

    if (!token) {
      navigate('/', { replace: true });
      return;
    }

    // Nettoyer le hash immédiatement (ne pas laisser les tokens dans l'historique)
    window.history.replaceState(null, '', window.location.pathname);

    setAccessToken(token);

    getMeApi()
      .then(user => {
        startImpersonation(user, token);
        navigate(ROUTES.ROLE_LANDING, { replace: true });
      })
      .catch(() => {
        navigate('/', { replace: true });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className='min-h-screen flex items-center justify-center'>
      <p className='text-slate-500 text-sm'>Connexion en tant que cet utilisateur…</p>
    </div>
  );
}
